import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { VideoSidebarLayout } from 'modules/queues/Schedule/containers';
import PermissionsPrompt from 'modules/notifications/components/PermissionsPrompt';
import VideoContentPending from 'modules/appointmentInfo/components/_placeholders/VideoContentPending';

import theme from './ExternalConferencePage.scss';

class ExternalConferencePage extends PureComponent {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isInStandaloneMode: PropTypes.bool.isRequired,
    isAppointmentFetching: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    window.intl = this.props.intl;
  }

  render() {
    const {
      isMobile,
      isInStandaloneMode,
      isAppointmentFetching,
    } = this.props;

    if (isAppointmentFetching) return <VideoContentPending />;

    return (
      <div className={ theme.root } id="rootPage">
        <VideoSidebarLayout />

        <If condition={ isMobile && isInStandaloneMode }>
          <PermissionsPrompt />
        </If>
      </div>
    );
  }
}

export default injectIntl(ExternalConferencePage);
